<template>
  <div>
    <div>
      <el-form size="small" label-width="100px" class="margin15-tb">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="模板名称">
              <el-input clearable v-model="templateName"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="模板内容">
              <el-input clearable v-model="templateContent" placeholder="前后加上#可搜索参数"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <div class="text left">
              <el-button type="primary" size="mini" @click="search">搜索</el-button>
              <el-button size="mini" @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <p>
        <el-button icon="el-icon-plus" type="primary" size="small" @click="addTemplate">创建模板</el-button>
        <el-button icon="el-icon-microphone" type="success" size="small" @click="generateTemplateVoice" v-if="this.$partB()" :disabled="!generateTemplateVoiceVisible">生成语音</el-button>
        <el-button type="warning" size="small" @click="batchReplaceRecorder" :disabled="!multipleSelection.length">批量替换录音员</el-button>

        <el-button type="success" size="small" @click="exportExcel">导出Excel</el-button>
        <el-button size="small"  type="danger" @click="uploadExcel()">场景模板导入</el-button>
      </p>
    </div>
    <el-dialog title="导入场景模板" width="30%" center :visible.sync="importDialogVisibleExcel">
      <el-form label-width="100px" >
        <el-form-item label="文件上传" >
          <el-upload
            class="upload-demo"
            action=""
            ref="upload"
            :before-remove="beforeRemove"
            :limit="1"
            :auto-upload="false"
            :on-change="handleChange"
            :file-list="fileList">
            <el-button size="small" icon="el-icon-upload" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">请用模板进行修改上传</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="default" size="small" icon="el-icon-bottom"><a href="/static/template/sceneTemplate.xlsx" download
            style="color: inherit; text-decoration: none;">模板下载</a></el-button>
        <el-button size="small" type="primary" @click="submitFile()">提交数据</el-button>
      </div>
    </el-dialog>
    <div class="padding15-tb">
      <el-table
        :data="list"
        v-loading="loading"
        size="small"
        border
        @selection-change="handleSelectionChange"
        :span-method="objectSpanMethod"
        :header-cell-style="{textAlign: 'center'}"
        style="width: 100%">
        <!-- 多选框 -->
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="name"
          align="center"
          label="模板名称"
          width="200px">
        </el-table-column>
        <el-table-column
          prop="labels"
          align="center"
          width="200px"
          label="标签">
        </el-table-column>
        <el-table-column
          prop="templateType"
          align="center"
          width="200px"
          label="模版类型">
        </el-table-column>
        <el-table-column
          prop="recorder"
          align="center"
          width="200px"
          label="录音员">
          <template slot-scope="scope">
              <span v-if="scope.row.recorder">{{ scope.row.recorder }}</span>
              <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="recorder"
          align="center"
          width="200px"
          label="特殊标识">
          <template slot-scope="scope">
            <span v-if="scope.row.logicName">{{ scope.row.logicName }}</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="contentShow"
          align="center"
          label="内容">
          <template slot-scope="scope">
              <div v-html="scope.row.contentShow"></div>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="150px">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-plus" v-if="scope.row.parentId === null"  @click="addChildTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-guide" @click="routeSceneShow(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="editTemplate(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-setting" @click="getTemplateParticipleList(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteTemplate(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200, 500]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="录音编辑" center :visible.sync="participleVisible">
      <el-table :data="participleList">
        <el-table-column
          property="content"
          align="center"
          label="类型">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.id === 0">主录音</el-tag>
            <el-tag v-else type="success">子录音</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          property="content"
          align="center"
          label="内容">
          <template slot-scope="scope">
            <div v-html="scope.row.content"></div>
          </template>
        </el-table-column>
        <el-table-column
          property="address"
          align="center"
          label="地址">
          <template slot-scope="scope">
            <span v-if="scope.row.sftpAddress" >
              <el-button type="text" @click="showButton(scope)" v-if="scope.row.showAddress === false">录音查看</el-button>
              <!-- <div class="audio" :id="'myAudios'+scope.$index" v-if="scope.row.showAddress === true" v-loading="scope.row.voiceLoading" element-loading-spinner="el-icon-loading"
                element-loading-background="#F5F7FA" style="height: 30px;width: 180px;outline: none;">
              </div> -->
              <div v-if="scope.row.showAddress === true" v-loading="scope.row.voiceLoading" class="audio" :id="'myAudio'+scope.$index" element-loading-spinner="el-icon-loading"
                element-loading-background="#F5F7FA" style="height: 30px;width: 180px;outline: none;">
              </div>
            </span>
            <!-- <div v-if="scope.row.sftpAddress" v-loading="scope.row.voiceLoading" class="audio" :id="'myAudio'+scope.$index" element-loading-spinner="el-icon-loading"
              element-loading-background="#F5F7FA" style="height: 30px;width: 180px;outline: none;">
            </div> -->
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column
          property="id"
          align="center"
          label="录音"
          min-width="150px">
          <template slot-scope="scope">
            <div v-if="scope.row.id === 0" >
              <el-button type="primary" @click="onStartVoice" round>开始</el-button>
              <el-button type="warning" @click="onEndVoice" round>结束</el-button>
              <el-button type="success" @click="onPlayAudio" round>试听</el-button>
              <el-button type="danger"  @click="uploadFile" round>上传</el-button>
              <div class="pd recpower">
                <div style="width:100%;background:rgb(37 47 74);font-size: 18px;text-align: center;position:relative;top:5px">
                  {{str}}
                </div>
                <br/>
              </div>
              <div class="record-play" v-show="isFinished">
                <h2>Current voice player is:</h2>
                <audio style="width: 70%;" id="audioVoice"  controls autoplay></audio>
              </div>
              <el-upload class="upload-demo"
                :on-change="fileChanged"
                multiple
                :limit="1"
                ref="upload" action='#' accept=".wav,.mp3,.m4a"
                :auto-upload="false"
                :show-file-list="false"
                :file-list="req.fileList.length===0?[]:req.fileList">
                <el-button size="small" type="warning" icon="el-icon-upload" @click="upload(scope.row)" circle></el-button>
                <div slot="tip" class="el-upload__tip">请上传本地录音</div>
              </el-upload>
            </div>
            <el-select v-else-if="scope.row.id !== 0 && scope.row.isFiled === 1" v-model="scope.row.sftpAddress" @change="addressChange(scope)" placeholder="请选择">
              <el-option
                v-for="item in aiFileList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

          </template>
        </el-table-column>
      </el-table>
      <div class="bg-content padding15" v-if="this.$hasPerm('B008&13')">
        <el-form size="small" label-width="50px" ref="searchRef">
          <el-row :gutter="24">
            <el-col :span="10">
              <el-form-item label="批次号" label-width="85px">
                <el-select v-model="searchCaseReq.batchNo" filterable collapse-tags placeholder="请选择" style="width: 100%;" clearable remote :remote-method="batchNoSearch" :loading="batchNoloading">
                  <el-option v-for="item in batchList" :key="item.id" :label="item.title" :value="item.id" :title="item.title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="进件号" label-width="85px">
                <el-input v-model="searchCaseReq.aCaseId" placeholder="请输入查询条件" style="width: 100%;" clearable/>
              </el-form-item>
            </el-col>
            <div style="display: inline-block; margin-left: 10px;">
                  <el-tooltip class="item" effect="light" placement="right">
                    <div slot="content">
                      甲方模版只能选甲方公司的案子生成试听录音，查看及下载
                    </div>
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </div>
            </el-row>
            <el-row :gutter="24">
            <el-col :span="6" >
              <div>
                <el-button type="primary" size="small" plain @click="generateTryRecording()"><i class="fa fa-search"></i> 生成试听录音</el-button>
              </div>
            </el-col >
            <el-col :span="6">
              <el-button size="small" @click="searchCaseReq.batchNo = null; searchCaseReq.aCaseId = null;">重置试听条件</el-button>
            </el-col>
            <el-col :span="6">
              <el-button @click="showButton1()" v-if="tryShowAddress === false">查看试听录音</el-button>
                <div v-loading="tryVoiceLoading" class="audio" id="myAudioTry"  element-loading-spinner="el-icon-loading"
                  element-loading-background="#F5F7FA" style="margin-left: -40px;height: 30px;width: 180px;outline: none;">
                </div>
            </el-col>
            <el-col :span="6">
              <div class="download">
                  <el-button @click="download1()">下载试听录音</el-button>
                </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="participleVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="saveParticiple">保存</el-button>
      </div>
    </el-dialog>

    <!-- 对话场景路由配置 -->
    <el-dialog title="场景模板路由配置" :visible.sync="routeSceneVisible" width="30%" center>
      <div>
        <el-form size="small" label-width="140px">
          <el-form-item label="场景模板路由">
            <el-select v-model="routeScene.routeConId" :value = "routeScene.routeConId" placeholder="请选择" style="width: 100%;" filterable clearable>
              <el-option
                v-for="item in routeSceneOption"
                :key="item.id"
                :label="item.confName"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="routeSceneVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="routeSceneSave">保存</el-button>
      </div>
    </el-dialog>

    <!-- 批量替换录音员弹窗 -->
    <el-dialog title="批量替换录音员" :visible.sync="recorderDialogVisible" width="30%" center>
      <div>
        <el-form size="small" label-width="80px">
          <el-form-item label="录音员">
            <el-select v-model="newRecorder" placeholder="请选择录音员" style="width: 100%;" filterable>
              <el-option
                v-for="item in recorderOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="recorderDialogVisible = false" size="small">取 消</el-button>
        <el-button type="primary" size="small" @click="confirmReplaceRecorder">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Record from '../../../../utils/record-sdk';

export default {
  props: {
    initTemplateFiled: {
      type: Function,
      default() {
      }
    },
    addOrEditTemplate: {
      type: Function,
      default() {
      }
    },
    openAndCloseTemplate: {
      type: Function,
      default() {
      }
    },
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '场景模板') {
        if (this.companyId !== '') {
          this.getData(1);
          this.getRouteSceneOption();
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
      this.generateTemplateVoiceVisible = true;
    },
    groupSelected(groupId) {
      this.groupId = groupId;
      if (this.changeTabe === '场景模板') {
        this.getData(1);
        this.getRouteSceneOption();
      }
      this.generateTemplateVoiceVisible = true;
    },
    companyAmount(amount) {
      this.amount = amount;
    }
  },
  data() {
    return {
      importDialogVisibleExcel: false,
      loading: true,
      list: [],
      spanArr: [],
      pos: 0,
      companyId: '',
      groupId: '',
      pageData: {},
      type: 'svoice',
      templateName: '',
      templateContent: '',
      templateOperType: {
        addMsg: 'addMsg',
        addVoice: 'addVoice',
        addIvoice: 'addIvoice',
        add: 'add',
        edit: 'edit',
        addChildTemplate: 'addChildTemplate',
        addSceneTemplate: 'addSceneTemplate'
      },
      participleList: [],
      participleVisible: false,
      req: {
        id: null,
        templateId: null,
        fileList: []
      },
      isVoice: false,
      isFinished: false,
      tipMsg: '录音',
      audio: '',
      recorder: new Record(),
      hour: 0, // 定义时，分，秒，毫秒并初始化为0；
      minute: 0,
      ms: 0,
      second: 0, // 秒
      time: '',
      str: '00:00:00',
      aiFileList: [],
      routeSceneVisible: false,
      routeScene: {
        id: null,
        routeConId: null,
        type: 2
      },
      routeSceneReq: {
        type: 2
      },
      routeSceneOption: [],
      multipleSelection: [],
      recorderDialogVisible: false,
      generateTemplateVoiceVisible: true,
      newRecorder: '',
      recorderOptions: [],
      fileList: [],
      searchCaseReq: {
        templateId: null,
        batchNo: null,
        aCaseId: null
      },
      tryVoiceLoading: false,
      tryShowAddress: false,
      batchList: [],
      batchListInit: [],
      batchNoloading: false
    };
  },
  mounted() {
    this.initTemplateFiled(this.templateOperType);
    this.batchNoSearch('');
  },
  methods: {
    getSpanArr(data) {
      this.spanArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else if (data[i].name === data[i - 1].name) {
          // 判断当前元素与上一个元素是否相同
          this.spanArr[this.pos] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.pos = i;
        }
      }
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rows = this.spanArr[rowIndex];
        const cols = rows > 0 ? 1 : 0;
        return {
          rowspan: rows,
          colspan: cols
        };
      }
      // 添加模板名称合并单元格
      if (columnIndex === 1) {
        const rows = this.spanArr[rowIndex];
        const cols = rows > 0 ? 1 : 0;
        return {
          rowspan: rows,
          colspan: cols
        };
      }
      return { rowspan: 1, colspan: 1 };
    },
    getData(page) {
      this.loading = true;
      this.$ajax({
        url: '/scene/getTemplates',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        this.list = [];
        this.$nextTick(() => {
          this.list = res.data.list;
          this.getSpanArr(this.list);
          this.pageData.pageSize = res.data.limit;
          this.pageData.totalCount = res.data.totalRecords;
          this.pageData.currentPage = res.data.currentPage;
          this.loading = false;
        });
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'type': this.type,
        'templateName': this.templateName,
        'templateContent': this.templateContent,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': 0,
        'sort': 0
      };
      return req;
    },
    getDataByFirst(companyId, groupId, page) {
      console.warn(page);
      this.companyId = companyId;
      this.groupId = groupId;
      this.getData(this.pageData.currentPage);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getData(val);
    },
    search() {
      this.getData(1);
    },
    uploadExcel() {
      this.importDialogVisibleExcel = true;
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    beforeRemove(file) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submitFile() {
      this.importDialogVisibleExcel = false;
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      if (this.fileList === [] || this.fileList === null || this.fileList.length === 0) {
        this.$message.error('excel文件不能为空!');
        loading.close();
      }
      const fileList = this.fileList;
      const FileExt = fileList[0].name.replace(/.+\./, '').toLowerCase();
      const xlsxFlag = ['xlsx'].includes(FileExt);
      const isLt5M = fileList[0].size / 1024 / 1024 < 5;
      if (!xlsxFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
        this.importDialogVisibleExcel = false;
      }
      if (!isLt5M) {
        this.$message.error('上传的文件大小不能超过 5MB!');
        this.fileList = [];
        loading.close();
        this.importDialogVisibleExcel = false;
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('groupId', this.groupId);
      formData.append('companyId', this.companyId);
      this.$ajax({
        url: '/strategy/excel/importScene',
        method: 'POST',
        prompt: true,
        contentType: 'multipart/form-data',
        data: formData
      }).then(() => {
        loading.close();
        this.importDialogVisibleExcel = false;
      }).catch(() => {
        loading.close();
        this.importDialogVisibleExcel = false;
      });
    },
    exportExcel() {
      this.$download({
        url: '/strategy/excel/exportSences',
        method: 'POST',
        data: this.getSearchParam(1),
        name: '场景模板列表.xlsx'
      });
    },
    reset() {
      this.resetSearchParam();
    },
    resetSearchParam() {
      this.templateName = '';
      this.templateContent = '';
    },
    addTemplate() {
      this.addOrEditTemplate(true, this.templateOperType.addSceneTemplate, this.companyId, this.groupId, null);
    },
    addChildTemplate(row) {
      this.addOrEditTemplate(true, this.templateOperType.addChildTemplate, this.companyId, this.groupId, row);
    },
    editTemplate(row) {
      this.addOrEditTemplate(true, this.templateOperType.edit, this.companyId, this.groupId, row);
    },
    getTemplateParticipleList(row) {
      this.aiFileList = [];
      this.participleList = [];
      this.searchCaseReq.templateId = row.id;
      this.searchCaseReq.aCaseId = null;
      this.searchCaseReq.batchNo = null;
      this.tryShowAddress = false;
      this.batchList = this.batchListInit;
      this.$ajax({
        url: '/template/getTemplateParticipleList',
        method: 'POST',
        params: { 'templateId': row.id }
      }).then((res) => {
        this.participleList = res.data;
        const s = {
          id: 0,
          content: row.content
        };
        this.participleList.push(s);
        this.participleList.forEach((element) => {
          if (element.sftpAddress) {
            const ai = {
              value: element.sftpAddress,
              label: element.sftpAddress.substring(element.sftpAddress.lastIndexOf('/') + 1)
            };
            this.aiFileList.push(ai);
          }
        });
        this.participleVisible = true;
        const bodyFa = document.getElementById('myAudioTry');
        bodyFa.innerHTML = '';
      });
    },
    // 上传音频
    fileChanged(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.aiFileList = [];
      this.req.fileList = fileList;
      const FileExt = file.name.replace(/.+\./, '').toLowerCase();
      const wavFlag = ['wav'].includes(FileExt);
      const mp3Flag = ['mp3'].includes(FileExt);
      const m4aFlag = ['m4a'].includes(FileExt);
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (!wavFlag && !mp3Flag && !m4aFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.req.fileList = [];
        loading.close();
      }
      if (!isLt10M) {
        this.$message.error('上传的文件大小不能超过 20MB!');
        this.req.fileList = [];
        loading.close();
      }
      console.warn(this.req.fileList);
      const formData = new FormData();
      formData.append('file', this.req.fileList[0].raw);
      formData.append('type', 1);
      if ((wavFlag || mp3Flag || m4aFlag) && isLt10M) {
        this.$ajax({
          url: '/scene/recordUpload',
          method: 'POST',
          prompt: true,
          contentType: 'multipart/form-data',
          data: formData
        }).then((res) => {
          if (res.data) {
            res.data.forEach((element) => {
              const ai = {
                value: element,
                label: element.substring(element.lastIndexOf('/') + 1)
              };
              this.aiFileList.push(ai);
            });
          }
          loading.close();
        });
      }
      return (wavFlag || mp3Flag || m4aFlag) && isLt10M;
    },
    upload(row) {
      this.req.id = row.id;
      this.req.templateId = row.templateId;
      this.req.fileList = [];
    },
    uploadFile() {
      this.aiFileList = [];
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const blob = this.recorder.getBlob();
      const fileName = `${new Date().getTime()}.wav`;
      const files = new window.File([blob], fileName);
      const formData = new FormData();
      formData.append('file', files);
      formData.append('type', 1);
      this.$ajax({
        url: '/scene/recordUpload',
        method: 'POST',
        prompt: true,
        contentType: 'multipart/form-data',
        data: formData
      }).then((res) => {
        console.warn(res);
        res.data.forEach((element) => {
          const ai = {
            value: element,
            label: element.substring(element.lastIndexOf('/') + 1)
          };
          this.aiFileList.push(ai);
        });
        loading.close();
      });
    },
    addressChange(scope) {
      // scope.row.address = null;
      this.$set(scope.row, 'voiceLoading', true);
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': scope.row.sftpAddress }
      }).then((re) => {
        document.getElementById(`myAudio${scope.$index}`).innerHTML = '';
        const blob = new Blob([re.data]);
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.controlsList = 'nodownload';
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById(`myAudio${scope.$index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(scope.row, 'voiceLoading', false);
      });
    },
    showButton(scope) {
      scope.row.showAddress = true;
      this.auditionVoice(scope.row, scope.$index);
    },
    // 录音试听
    auditionVoice(row, index) {
      this.$set(row, 'voiceLoading', true);
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': row.sftpAddress }
      }).then((re) => {
        const blob = new Blob([re.data], { type: 'audio/wav' });
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById(`myAudio${index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(row, 'voiceLoading', false);
      });
    },
    saveParticiple() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const plist = [];
      this.participleList.forEach((participle) => {
        if (participle.isFiled === 1) {
          const p = {
            id: participle.id,
            sftpAddress: participle.sftpAddress
          };
          plist.push(p);
        }
      });
      this.$ajax({
        url: '/scene/saveParticiple',
        method: 'POST',
        prompt: true,
        data: plist
      }).then((res) => {
        console.warn(res);
        loading.close();
        this.participleVisible = false;
      }).finally(() => {
        loading.close();
      });
    },
    // 开始计时
    timeStart() {
      this.time = setInterval(this.timer(), 50);
    },
    timer() { // 定义计时函数
      this.ms = this.ms + 50; // 毫秒
      if (this.ms >= 1000) {
        this.ms = 0;
        this.second = this.second + 1; // 秒
      }
      if (this.second >= 60) {
        this.second = 0;
        this.minute = this.minute + 1; // 分钟
      }
      if (this.minute >= 60) {
        this.minute = 0;
        this.hour = this.hour + 1; // 小时
      }
      //
      this.str = `${this.toDub(this.hour)}:${this.toDub(this.minute)}:${this.toDub(this.second)}`;/* +""+this.toDubms(this.ms)+"毫秒" */
      // document.getElementById('mytime').innerHTML=h+"时"+m+"分"+s+"秒"+ms+"毫秒";
    },
    // 补零操作
    toDub(n) { // 补0操作
      if (n < 10) {
        return `0${n}`;
      }
      return `${n}`;
    },
    // 时间重置
    timeReset() {
      clearInterval(this.time);
      // this.hour =0
      this.minute = 0;
      this.ms = 0;
      this.second = 0;
      this.str = '00:00:00';
    },
    // 开始录音
    onStartVoice() {
      this.timeReset();
      this.onStopAudio();
      this.isFinished = false;
      this.time = setInterval(this.timer, 50);
      this.recorder.startRecord({
        success: (res) => {
          console.warn(res);
          this.isVoice = true;
        },
        error: (e) => {
          this.isVoice = false;
          this.$toast(e);
        }
      });
    },
    // 结束录音
    onEndVoice() {
      clearInterval(this.time);
      this.isFinished = false;
      this.recorder.stopRecord({
        success: (res) => {
          this.isVoice = false;
          // 此处可以获取音频源文件(res)，用于上传等操作
          console.warn('音频源文件', res);
        },
        error: (e) => {
          console.warn(e);
          this.isVoice = false;
        }
      });
    },

    // 播放录音
    onPlayAudio() {
      this.isVoice = false;
      this.isFinished = true;
      this.audio = document.getElementById('audioVoice');
      this.recorder.play(this.audio);
    },

    // 停止播放录音
    onStopAudio() {
      this.recorder.clear(this.audio);
    },
    deleteTemplate(id) {
      this.$confirm('确定删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          url: '/scene/deleteTemplate',
          prompt: true,
          method: 'POST',
          data: {
            'id': id,
            'status': true
          }
        }).then(() => {
          this.search();
          window.eventBus.$emit('templateHadChange', null);
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    generateTemplateVoice() {
      this.$confirm('确定重新生成机器分词录音?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$ajax({
          url: '/scene/generateTemplateVoice',
          prompt: true,
          method: 'POST',
          data: {
            'companyId': this.companyId,
            'groupId': this.groupId
          }
        }).then(() => {
          this.generateTemplateVoiceVisible = false;
          loading.close();
          this.search();
        }).catch(() => {
          loading.close();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消生成录音'
        });
      });
    },
    routeSceneShow(row) {
      this.routeScene.id = row.id;
      this.routeScene.routeConId = row.routeConId;
      this.routeSceneVisible = true;
    },
    routeSceneSave() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/scene/routeScene',
        data: this.routeScene
      }).then(() => {
        loading.close();
        this.routeSceneVisible = false;
        this.getData(1);
      }).catch(() => {
        loading.close();
      });
    },
    getRouteSceneOption() {
      this.routeSceneReq.companyId = this.companyId;
      this.routeSceneReq.groupId = this.groupId;
      this.$ajax({
        method: 'get',
        url: '/commonRoute/listByCompanyId',
        params: this.routeSceneReq
      }).then((res) => {
        this.routeSceneOption = res.data;
      });
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 打开批量替换录音员弹窗
    batchReplaceRecorder() {
      this.recorderDialogVisible = true;
      this.newRecorder = '';
      // 获取录音员列表
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: {
          status: 1
        }
      }).then((res) => {
        console.warn(res);
        if (res.data && Array.isArray(res.data)) {
          this.recorderOptions = res.data;
        } else {
          this.recorderOptions = [];
          this.$message.warning('获取录音员列表失败');
        }
      }).catch(() => {
        this.recorderOptions = [];
        this.$message.error('获取录音员列表失败');
      });
    },
    // 确认批量替换录音员
    confirmReplaceRecorder() {
      if (!this.newRecorder) {
        this.$message.warning('请选择录音员');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      const requestData = {
        ids: this.multipleSelection.map(item => item.id),
        recorderId: this.newRecorder
      };
      this.$ajax({
        url: '/scene/batchUpdateRecorder',
        method: 'POST',
        data: requestData
      }).then(() => {
        this.$message.success('批量替换成功');
        this.recorderDialogVisible = false;
        this.getData(this.pageData.currentPage);
      }).finally(() => {
        loading.close();
      });
    },
    showButton1() {
      this.tryShowAddress = true;
      this.auditionVoice1(this.searchCaseReq.templateId);
    },
    // 录音试听
    auditionVoice1(tempalteId) {
      this.tryVoiceLoading = true;
      this.$downloadVoice({
        url: `/scene/getTryRecord/${tempalteId}`,
        method: 'GET',
        responseType: 'blob'
      }).then((res) => {
        // 关键检查：判断响应是否是错误JSON（后端异常时）
        if (res.data.type.includes('json')) {
          // 将Blob转换为文本读取错误信息
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                reject({
                  msg: errorData.msg || '未找到试听文件'
                });
              } catch (e) {
                reject({
                  msg: '解析错误信息失败'
                });
              }
            };
            reader.readAsText(res.data);
          });
        }

        const blob = new Blob([res.data]);
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.controlsList = 'nodownload';
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById('myAudioTry');
        bodyFa.innerHTML = '';
        bodyFa.appendChild(frameAudio);
        return blob;
      }).catch((error) => {
        this.$notify.error({
          title: '错误',
          message: error.msg
        });
        this.tryShowAddress = false;
        const bodyFa = document.getElementById('myAudioTry');
        bodyFa.innerHTML = '';
      }).finally(() => {
        this.tryVoiceLoading = false;
      });
    },
    // 录音下载
    download1() {
      const tempalteId = this.searchCaseReq.templateId;
      this.$downloadVoice({
        method: 'GET',
        url: `/scene/downloadTryRecord/${tempalteId}`,
        responseType: 'blob'
      }).then((res) => {
        // 关键检查：判断响应是否是错误JSON（后端异常时）
        if (res.data.type.includes('json')) {
          // 将Blob转换为文本读取错误信息
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const errorData = JSON.parse(reader.result);
                reject({
                  msg: errorData.msg || '未找到试听文件'
                });
              } catch (e) {
                reject({
                  msg: '解析错误信息失败'
                });
              }
            };
            reader.readAsText(res.data);
          });
        }
        const blob = new Blob([res.data]);
        const fileName = `tryRecord_${Date.parse(new Date())}.wav`;
        if (window.navigator.msSaveOrOpenBlob) {
          // console.log(2)
          navigator.msSaveBlob(blob, fileName);
        } else {
          // console.log(3)
          const link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          // 释放内存
          window.URL.revokeObjectURL(link.href);
        }
        return blob;
      }).catch((error) => {
        this.$notify.error({
          title: '错误',
          message: error.msg
        });
      });
    },
    // 生成试听录音
    generateTryRecording() {
      this.$ajax({
        url: '/scene/generateTryRecording',
        method: 'POST',
        data: this.searchCaseReq
      }).then(() => {
        this.tryShowAddress = false;
        const bodyFa = document.getElementById('myAudioTry');
        bodyFa.innerHTML = '';
        this.$notify({
          title: '成功',
          message: '试听录音生成成功！！',
          type: 'success'
        });
      });
    },
    batchNoSearch(val) {
      this.batchNoloading = true;
      this.$ajax({
        url: '/robotCase/getBatchDataList',
        params: { 'val': val, 'testing': false, 'batchId': null }
      }).then((res) => {
        this.batchList = this.optionsHandler(res.data);
        if (val === '') {
          this.batchListInit = this.batchList;
        }
        this.batchNoloading = false;
      });
    },
    optionsHandler(options) {
      return options.map((element) => {
        element.title = `${element.companyName.substring(0, 6)}...(${element.batchNo})`;
        return element;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/collection/engine/scene_template.vue